import React from 'react';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import EnhancedButton from 'material-ui/internal/EnhancedButton';
import MenuItem from 'material-ui/MenuItem';
import { injectIntl, intlShape } from 'react-intl';
import { map } from 'ramda';

import { crumbButton } from './Toolbar.less';

// Maps the menu items from navigation sections (passed down).
const mapMenu = (msg, sections) => map(i => <MenuItem key={i.name} value={i.name} primaryText={msg(i)} />, sections);

// A function that is given the navigate function, returns a function that is called when the user clicks on
// a navigation menu item.
const onNavigate = navigate => (e, i) => navigate(`${DOCUMENTS_PATH}/${i}`);

// The dropdown button that is visible on the toolbar and triggers the menu when clicked.
// We use the EnhancedButton hoc from material ui to provide IconMenu integration.
const dropdownButton = clickElement => <EnhancedButton children={clickElement} />;

// The actual dropdown element, injectIntl is used to provide the intl prop.
const NavigationDropdown = injectIntl(({ items, navigate, sections, clickElement, intl: { formatMessage } }) => (
  <IconMenu iconButtonElement={dropdownButton(clickElement)} onChange={onNavigate(navigate)}>
    {mapMenu(formatMessage, sections)}
  </IconMenu>
));

NavigationDropdown.propTypes = {
  items: PropTypes.array,
  navigate: PropTypes.func,
  sections: PropTypes.array,
  clickElement: PropTypes.element,
  intl: intlShape,
};

export default NavigationDropdown;
